// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__mfW_5","productName":"Table_productName__1wL-l"};